"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isList_1 = __importDefault(require("./isList"));
/**
 * Return the parent list block for an item block.
 */
var getListForItem = function (opts) { return function (value, item) {
    var document = value.document;
    var parent = document.getParent(item.key);
    return parent && isList_1.default(opts)(parent) ? parent : null;
}; };
exports.default = getListForItem;
//# sourceMappingURL=getListForItem.js.map